import { render, staticRenderFns } from "./signUpMobile.vue?vue&type=template&id=6bb2cf68&scoped=true"
import script from "./signUpMobile.vue?vue&type=script&lang=js"
export * from "./signUpMobile.vue?vue&type=script&lang=js"
import style0 from "./signUpMobile.vue?vue&type=style&index=0&id=6bb2cf68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2cf68",
  null
  
)

export default component.exports